import {FC} from 'react'

import {useRecentArticlesContent} from '@/content/recentArticles'
import {Link, useTranslation} from '@/i18n'
import {theme} from '@/theme/theme'
import {RecentArticleCard} from '@/utils/contentful'
import {TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'
import {analytics} from '@/utils/tracking/analytics'
import {AnalyticsTrackedEvent} from '@/utils/tracking/types'

import {BlogArticleCard} from '../cards/BlogArticleCard'
import {CardListLayout} from '../cards/CardListLayout'
import {CardWrapper} from '../cards/CardWrapper'
import {Button} from '../content/Button'
import {ArrowIcon} from '../icons/ArrowIcon'

type MostRecentArticlesProps = {
  articles: RecentArticleCard[]
  articlesTitle?: string
  trackedEvent: AnalyticsTrackedEvent
}

export const MostRecentArticles: FC<React.PropsWithChildren<MostRecentArticlesProps>> = ({
  articles,
  articlesTitle,
  trackedEvent,
}) => {
  const {t} = useTranslation('page')
  const {title, buttonLinkUrl, buttonLinkText} = useRecentArticlesContent()

  return (
    <>
      <CardListLayout title={articlesTitle || t(title)}>
        {articles.map(({key, title, image, excerpt, href}) => (
          <CardWrapper key={key}>
            <BlogArticleCard
              title={title}
              excerpt={excerpt}
              linkHref={href}
              imageSrc={image.url}
              imageAlt={image.alt}
              trackedEvent={trackedEvent}
              titleMaxLines={2}
            />
          </CardWrapper>
        ))}
      </CardListLayout>
      <div className="button-wrapper">
        <Link
          href={buttonLinkUrl}
          onClick={() => analytics.track(trackedEvent.name, trackedEvent.parameters)}
        >
          <Button icon={<ArrowIcon />} type="button" isHoverable>
            {t(buttonLinkText)}
          </Button>
        </Link>
      </div>

      <style jsx>{`
        .button-wrapper {
          text-align: center;
          margin-top: ${theme.spacing[7]};
        }
        @media ${TABLET_SCREENSIZE} {
          .button-wrapper {
            margin-top: ${theme.spacing[6]};
          }
        }
      `}</style>
    </>
  )
}
